import React, { forwardRef } from 'react';
import { getImplicitPlatform } from '../App';

type PlatformProps = {
    web: React.ComponentType<any>;
    mobile: React.ComponentType<any>;
    [key: string]: React.ComponentType<any>;
};

// Ajout de forwardRef pour pouvoir passer le ref au composant interne
const withPlatformComponent = (components: PlatformProps) => {
    return forwardRef((props: any, ref) => {
        const platform = getImplicitPlatform();
        const ComponentToRender = components[platform] || components.mobile;

        // Utiliser React.createElement pour transmettre le ref
        return React.createElement(ComponentToRender, { ...props, ref, key: platform });
    });
};

export default withPlatformComponent;
